import Vue from "vue";
import router from "@/router";
import conf from "./brands";
import store from "@/store";
import {
  obtenerTrackingCode,
  obtenerDeviceId,
  obtenerDeviceIdTimestamp
} from "@/utils";
import { mapState } from "vuex";
import get from "lodash/get";
import * as ACTIONS from "../config/constants/action-types";

const values = {};

const config = {
  install(Vue) {
    // Voy a buscar el tracking code y lo guardo en el store
    try {
      store.dispatch(ACTIONS.doTCode, obtenerTrackingCode());
    } catch (e) {
      //
    }

    /**
     * Setear deviceId
     */
    try {
      store.dispatch(ACTIONS.DO_GET_DEVICEID, obtenerDeviceId());
    } catch (e) {
      Vue.$log.error("Error obteniendo el deviceId: " + e);
    }

    /**
     * Setear deviceIdTimestamp
     */
    try {
      store.dispatch(
        ACTIONS.DO_GET_DEVICEIDTIMESTAMP,
        obtenerDeviceIdTimestamp()
      );
    } catch (e) {
      Vue.$log.error("Error obteniendo el timeStamp: " + e);
    }

    Vue.mixin({
      mounted() {},
      computed: {
        config() {
          return this.$config.get();
        },
        ...mapState({
          /**
           * Poner la key de la current view en el state
           */
          currentView: state => {
            return get(state, "route.meta", {});
          }
        })
      }
    });
  },
  start(_callback) {
    // Voy a buscar la config del Branding
    // Guardo la config en la instancia local
    values.json = conf;
    // Armo los 'routes' usando los pasos
    let routes = [];
    for (let key in conf.pasos) {
      // eslint-disable-next-line no-prototype-builtins
      if (conf.pasos.hasOwnProperty(key)) {
        let route = conf.pasos[key];

        // Armo un objeto para guardar el 'route'
        let routeSave = {};
        routeSave.path = route.path;

        // Como 'route.name', el key en la config
        routeSave.name = key;
        routeSave.component = () => import("@/" + route.component);
        routes.push(routeSave);
      }
    }

    router.addRoutes(routes);
    _callback();
  },
  get() {
    return values.json;
  },
  /*
  set(name, value) {
    Vue.set(this.values.json, name, value);
  },*/
  getPasoProperties(paso) {
    return this.get().pasos[paso];
  }
};

Vue.prototype.$config = config;

export default config;
